import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { AssignableUserProfile } from '@savgroup-front-common/core/api/Authorization/listUserProfileQuery';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/upsertUserProfile`;

export type UserProfileSummary = AssignableUserProfile;

export interface UpsertUserProfileCommandArgs {
  userProfileId?: string;
  name?: string;
  tenantId?: string;
  roleIds?: string[];
  profileIds?: string[];
  permissions?: string[];
  cumulDashboardIds?: string[];
}

export const upsertUserProfileRequest = ({
  cumulDashboardIds,
  name,
  permissions,
  roleIds,
  profileIds,
  tenantId,
  userProfileId,
}: UpsertUserProfileCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: {
      cumulDashboardIds,
      name,
      permissions,
      roleIds,
      tenantId,
      userProfileId,
      profileIds,
    },
  },
});

export async function upsertUserProfileCommand(
  payload: UpsertUserProfileCommandArgs,
): Promise<BackResponse<UserProfileSummary> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<UserProfileSummary>>(
      upsertUserProfileRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
